import Vue from "vue";
import VueResource from "vue-resource";

import config from "../config/dev.js";
import axios from "axios";
import { Message } from "element-ui";

Vue.use(VueResource);

function deleteCookie(name, path) {
  var name = EnEight(escape(name));
  var expires = new Date(0);
  path = path == "" ? "" : ";path=" + path;
  document.cookie = name + "=" + ";expires=" + expires.toUTCString() + path; //toUTCString根据世界时 (UTC) 把 Date 对象转换为字符串
}

/*8进制加密*/
function EnEight(value) {
  var monyer = new Array();
  for (var i = 0; i < value.length; i++) {
    monyer += "\\" + value.charCodeAt(i).toString(8);
  }
  return monyer;
}
/*8进制解密*/
function DeEight(value) {
  var monyer = new Array();
  var s = value.split("\\");
  for (var i = 1; i < s.length; i++) {
    monyer += String.fromCharCode(parseInt(s[i], 8));
  }
  return monyer;
}

function setCookie(name, value, hours, path) {
  var name = EnEight(escape(name));
  var value = EnEight(escape(value));
  var expires = new Date();
  expires.setTime(expires.getTime() + hours * 3600000); //setTime() 方法以毫秒设置 Date 对象
  path = path == "" ? "" : ";path=" + path;
  var _expires =
    typeof hours == "string" ? "" : ";expires=" + expires.toUTCString();
  document.cookie = name + "=" + value + _expires + path;
}

function getCookieValue(name) {
  var name = EnEight(escape(name));
  var allcookies = document.cookie;
  name += "=";
  var pos = allcookies.indexOf(name);
  if (pos != -1) {
    var start = pos + name.length;
    var end = allcookies.indexOf(";", start);
    if (end == -1) end = allcookies.length;
    var value = allcookies.substring(start, end);
    return DeEight(unescape(value)); //对它解码
  } else return ""; //搜索失败，返回空字符串
}

// if (Storage.get('userData')) {
Vue.http.options.emulateJSON = true;
Vue.http.interceptors.push((request, next) => {
  request.headers.set("Content-Type", "application/json; charset=UTF-8");
  request.headers.set("Content-Type", "application/json");
  request.headers.set(
    "Authorization",
    "Bearer d1d43f88-e60b-47da-b937-83aaff84f40d"
  ); //setting request.headers
  next((response) => {
    return response;
  });
});
// }

let service = new Vue({
  methods: {
    ajax: function(option) {
      var loading;
      if (option.loading) {
        loading = this.$loading({
          // lock: true,
          text: "Loading",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
      }
      option.url = config.url + option.url;
      var type = option.type.toLowerCase();
      if (type == "get" || type == "delete") {
        axios({
          method: type,
          url: option.url,
          headers: {
            "X-Authorization": "Q5f0vbLm0IuhvjQGCwU5ioasikWydTyOhgsdJkzD2OI=",
            "Content-Type": "application/json;charset=UTF-8",
          },
          params: option.params,
        })
          .then((response) => {
            if (response.data.hasOwnProperty("error")) {
              // const element = response.body['error'];
              if (option.error) {
                option.error(response.message);
              } else {
                setTimeout(() => {
                  Message({
                    message: response.message,
                    type: "error",
                    center: true,
                  });
                  //$toast.show(response.message, 1500);
                }, 500);
              }
            } else {
              option.success(response.data);
            }
            if (option.loading) {
              loading.close();
            }

            // if (response.status == 200) {

            // } else {
            //     if (option.loading) {
            //         $loading.hide();
            //     };
            //     if (option.error) {
            //         option.error(response.data);
            //     } else {
            //         setTimeout(() => {
            //             $toast.show(response.data.message, 1500);
            //         }, 500);
            //     };
            // };
          })
          .catch((resp) => {
            if (option.loading) {
              loading.close();
            }
            if (option.error) {
              option.error(resp.message);
            } else {
              setTimeout(() => {
                Message({
                  message: resp.message,
                  type: "error",
                  center: true,
                });
              }, 500);
            }
          });
        // this.$http[type](option.url).then((response) => {
        //     if (option.loading) {
        //         $loading.hide();
        //     };
        //     if (response.body.hasOwnProperty('error')) {
        //         // const element = response.body['error'];
        //         if (option.error) {
        //             option.error(response.body);
        //         } else {
        //             setTimeout(() => {
        //                 $toast.show(response.body.message, 1500);
        //             }, 500);
        //         }
        //     } else {
        //         option.success(response.body);
        //     };
        // }, (response) => {

        // }).catch((error) => {
        //     if (option.loading) {
        //         $loading.hide();
        //     };
        //     setTimeout(() => {
        //         $toast.show(error.message, 1500);
        //     }, 500);
        // });
      } else if (type == "post" || type == "put") {
        axios({
          method: type,
          url: option.url,
          data: option.data,
          // contentType:'application/json',
          headers: {
            "X-Authorization": "Q5f0vbLm0IuhvjQGCwU5ioasikWydTyOhgsdJkzD2OI=",
            "Content-Type": "application/json;charset=UTF-8",
          },
        })
          .then((response) => {
            // console.log(response);

            if (response.data.hasOwnProperty("error")) {
              // const element = response.body['error'];
              if (option.error) {
                option.error(response.data);
              } else {
                setTimeout(() => {
                  Message({
                    message: response.data.message,
                    type: "error",
                    center: true,
                  });
                }, 500);
              }
            } else {
              option.success(response.data);
            }
            if (option.loading) {
              loading.close();
            }

            // if (response.status == 200) {

            // } else {

            // };
          })
          .catch((resp) => {
            if (option.loading) {
              loading.close();
            }
            if (option.error) {
              option.error(resp.response);
            } else {
              //console.log(resp);
              setTimeout(() => {
                Message({
                  message: resp.message,
                  type: "error",
                  center: true,
                });
              }, 2500);
            }
          });

        // this.$http[type](option.url, option.data).then((response) => {
        //     if (option.loading) {
        //         $loading.hide();
        //     };
        //     if (response.body.hasOwnProperty('error')) {
        //         // const element = response.body['error'];
        //         if (option.error) {
        //             option.error(response.body);
        //         } else {
        //             setTimeout(() => {
        //                 $toast.show(response.body.message, 1500);
        //             }, 500);
        //         }
        //     } else {
        //         option.success(response.body);
        //     };
        // }, (response) => {
        //     if (option.loading) {
        //         $loading.hide();
        //     };
        //     if (option.error) {
        //         option.error(response.body);
        //     } else {
        //         setTimeout(() => {
        //             $toast.show(response.body.message, 1500);
        //         }, 500);
        //     };
        // }).catch((error) => {
        //     if (option.loading) {
        //         $loading.hide();
        //     };
        //     setTimeout(() => {
        //         $toast.show(error.message, 1500);
        //     }, 500);
        // });
      }
    },
    get: function(option) {
      option.type = "get";
      this.ajax(option);
    },
    post: function(option) {
      option.type = "post";
      this.ajax(option);
    },
    put: function(option) {
      option.type = "put";
      this.ajax(option);
    },
    delete: function(option) {
      option.type = "delete";
      this.ajax(option);
    },
    storageSet: function(key, value) {
      Storage.set(key, value);
      setCookie(key, value, 168, "/");
    },
    storageGet: function(key) {
      var StorageValue = Storage.get(key);
      if (StorageValue) {
        return Storage.get(key);
      } else {
        var Cookie = getCookieValue(key);
        return Cookie;
      }
    },
    storageClear: function(key) {
      Storage.clear(key);
      deleteCookie(key, "/");
    },
  },
});

export default service;
